import React from 'react';

// local imports
import InformationBox from 'components/InformationBox';
import * as S from './styles';

export const TooSickContent = () => {
  return (
    <S.ContentWrapper>
      <S.Heading>We recommend that you seek medical attention now.</S.Heading>
      <S.ContentInner>
        <S.P>
          Based on your symptoms, we recommend that you not delay medical
          attention and seek testing from your healthcare provider immediately
          rather than wait for an at-home collection test. Please reach out to
          your healthcare provider as soon as possible to discuss your next
          steps in care.
        </S.P>
        <S.ListHeading>If you seek medical attention:</S.ListHeading>
        <S.UL>
          <S.LI>
            Call ahead before visiting the facility. This will help the facility
            keep other people from possibly getting infected or exposed.
          </S.LI>
          <S.LI>Tell the healthcare provider that you may have COVID-19.</S.LI>
          <S.LI>Avoid using public transportation, ride-sharing or taxis.</S.LI>
          <S.LI>Put on a facemask before you enter the facility.</S.LI>
        </S.UL>
        <InformationBox text="If at any time you feel like you are having a medical emergency, please call 9-1-1." />
      </S.ContentInner>
    </S.ContentWrapper>
  );
};

export default TooSickContent;
